<template>
  <div class="statement-collapse">
    <b-collapse :id="id" class="w-100" :visible="opened">
      <div :key="i" v-for="(item, i) in fees" class="mb-3">
        <b-row>
          <b-col :lg="9" class="d-flex">
            <div class="subtitle">{{ item.type }}</div>
            <span class="invoice-spacer"></span>
            <div>{{ item.value | currency(currency) }}</div>
          </b-col>
          <b-col :lg="12" v-if="item.text">
            <div class="text-secondary">({{ item.text }})</div>
          </b-col>
        </b-row>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ['fees', 'opened', 'currency', 'statement'],
  computed: {
    id() {
      if (this.statement) {
        return `collapse-${this.statement.type}-${this.statement.id}`
      } else {
        return 'collapse-charges'
      }
    }
  }
}
</script>
